export enum ContentContextTypes {
  GENERIC = 'GENERIC',
  CONTENT_ENGAGEMENT = 'CONTENT_ENGAGEMENT',
}
